/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import PayRollNoteOptionComponent from './payRollNoteOptions.component';
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import { Constants } from '../../config/appConstants';
import { MessageBox } from '../sharedComponent/messageBox';
import * as actions from '../../actions/login.Action';
/* Project Import will be here */

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class PayRollNoteOptionPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            payRollNoteOptionDataList: [],
            isOpenModel: false,
            pagination: {
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            },
            selectedValue: {},
            isEditPayRollNoteOption: false,
            payRollNoteOptionNameSearchText: "",
            isSetButtonDisabled: false,
            isDeleteConfiram: false,
            selectedIdForDelete: ""
        };
    }

    componentDidMount() {
        this.getPayRollNoteOptionsList();
    }

    getPayRollNoteOptionDetails(payRollNoteOptionId) {
        let { selectedValue } = this.state;
        let url = `${ApiUrls.Routes.PAYROLL_C}${ApiUrls.Routes.GT_PYRLNTE_M}?payRollNoteId=${payRollNoteOptionId}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    responseData.data.payRollNotes.forEach((a) => {
                        selectedValue.payRollNoteOptionName = a.name;
                        selectedValue.payRollNoteOptionId = a.id;
                        selectedValue.isActive = a.isActive;
                        selectedValue.isDeleted = a.isDeleted;
                    });
                    this.setState({ selectedValue, isEditPayRollNoteOption: true });
                }
            }
        });
    }

    getPayRollNoteOptionsList() {
        let { payRollNoteOptionNameSearchText, pagination } = this.state;
        let searchArray = [];
        if (payRollNoteOptionNameSearchText) {
            let searchObj = {
                FieldName: Constants.PAYROLLNOTEOPTION_NAME_SEARCH,
                Value: payRollNoteOptionNameSearchText
            };
            searchArray.push(searchObj);
        };
        let requestData = {
            SearchText: searchArray,
            Skip: pagination.skip,
            Take: pagination.take
        }
        let url = `${ApiUrls.Routes.PAYROLL_C}${ApiUrls.Routes.GT_PYRLNTE_LT_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                    let dropdownList = responseData.data.sort((a, b) => {
                        var nameA = a.name.toUpperCase();
                        var nameB = b.name.toUpperCase();
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        //name must be equal
                        return 0;
                    });
                    this.setState({
                        payRollNoteOptionDataList: dropdownList,
                        pagination
                    });
                }
                else {
                    this.setState({
                        payRollNoteOptionDataList: []
                    });
                }
            }
        });
    }

    onPageChange = (e, { activePage }) => {
        let { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;
        this.setState({
            pagination
        }, () => {
            this.getPayRollNoteOptionsList();
        });
    }

    onPayRollNoteOptionSearch = event => {
        this.setState({ payRollNoteOptionNameSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getPayRollNoteOptionsList();
        });
    }

    handlePayRollNoteOptionChange = (e, { value }) => {
        let { selectedValue } = this.state;
        selectedValue.payRollNoteOptionName = value;
        this.setState({ selectedValue });
    }

    onOpenModel = payRollNoteOptionDetails => {
        if (payRollNoteOptionDetails.payRollNoteOptionId) {
            this.getPayRollNoteOptionDetails(payRollNoteOptionDetails.payRollNoteOptionId);
        }
        this.setState({
            isOpenModel: true,
            selectedValue: {},
            isSetButtonDisabled: false
        });
    }

    onCloseModel = () => {
        this.setState({ isOpenModel: false, isEditPayRollNoteOption: false, selectedValue: {} }, () => this.getPayRollNoteOptionsList());
    }

    onSavePayRollNoteOption(payRollNoteOptionId) {
        let { selectedValue } = this.state;
        this.setState({ isSetButtonDisabled: true });
        if (!selectedValue.payRollNoteOptionName || !selectedValue.payRollNoteOptionName.trim()) {
            MessageBox(Constants.PLEASE_ENTER_PAYROLLOPTION_NAME, Constants.ERROR);
            this.setState({ isSetButtonDisabled: false });
            return;
        }
        let requestData = {
            Id: payRollNoteOptionId,
            Name: selectedValue.payRollNoteOptionName.trim(),
            IsActive: selectedValue.isActive,
        }
        let url = `${ApiUrls.Routes.PAYROLL_C}${ApiUrls.Routes.SV_PYRNTE_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
            this.setState({ isSetButtonDisabled: false });
            if (responseData.success) {
                this.onCloseModel();
            }
        });
    }

    onDeletePayRollNoteOption = (payRollNoteOptionDetails) => {
        this.setState({ isDeleteConfiram: true, selectedIdForDelete: payRollNoteOptionDetails.payRollNoteOptionId });
    }
    onCancelDelete = () => {
        this.setState({ isDeleteConfiram: false, selectedValue: {} });
    }
    onConfirmDelete = () => {
        let { selectedIdForDelete } = this.state;
        let url = `${ApiUrls.Routes.PAYROLL_C}${ApiUrls.Routes.DLT_PYRNTE_M}?payRollNoteId=${selectedIdForDelete}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData.success) {
                this.setState({ isDeleteConfiram: false, selectedValue: {} }, () => {
                    var apage = Math.ceil((this.state.pagination.totalRecordCount - 1) / Constants.DEFAULT_TAKE);
                    this.onPageChange(null, { activePage: this.state.pagination.activePage > apage ? apage : this.state.pagination.activePage });
                });
            }
            MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
        });
    }

    render() {
        const { payRollNoteOptionDataList, isEditPayRollNoteOption, isSetButtonDisabled, groupAccess,
            Division, selectedValue, group, isOpenModel, pagination, isDeleteConfiram } = this.state;
        return (
            <Fragment>
                <PayRollNoteOptionComponent
                    {...{
                        payRollNoteOption: {
                            payRollNoteOptionDataList,
                            isOpenModel,
                            pagination,
                            groupAccess,
                            Division,
                            group,
                            selectedValue,
                            isEditPayRollNoteOption,
                            isSetButtonDisabled,
                            isDeleteConfiram
                        }
                    }}
                    onOpenModel={this.onOpenModel.bind(this)}
                    onCloseModel={this.onCloseModel.bind(this)}
                    onSavePayRollNoteOption={this.onSavePayRollNoteOption.bind(this)}
                    onPayRollNoteOptionSearch={this.onPayRollNoteOptionSearch.bind(this)}
                    //onStatusSearch={this.onStatusSearch.bind(this)}
                    handlePayRollNoteOptionChange={this.handlePayRollNoteOptionChange.bind(this)}
                    onPageChange={this.onPageChange.bind(this)}
                    user={this.props.user}
                    //onClickSetButton={this.onClickSetButton.bind(this)}
                    onCancelDelete={this.onCancelDelete.bind(this)}
                    onDeletePayRollNoteOption={this.onDeletePayRollNoteOption.bind(this)}
                    onConfirmDelete={this.onConfirmDelete.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PayRollNoteOptionPage));
PayRollNoteOptionPage.displayName = 'PayRollNoteOptionPage';